module.exports = __webpack_public_path__ + "static/icon-0f7ccc963d1010c2bb5d4f1a524365e0.png";